import { takeLatest, put, call, take, fork, takeEvery } from 'redux-saga/effects';

import getConfig from 'Util/Config';
import fetch2, { METHOD } from 'Util/fetch';
import { accessTokenService } from 'Util/Hooks/useAccessToken';

import getApolloClient from '../../GraphQL';
import { callApi } from '../callApi/actions';

import {
  setProfile,
  setProfileLoading,
  USER_PROFILE_VALIDATE_LOGIN,
  USER_PROFILE_LOGIN,
  USER_PROFILE_LOGOUT,
  USER_PROFILE_LOGIN_SUCCESS,
  USER_PROFILE_LOGIN_REQUEST,
  USER_PROFILE_LOGIN_FAIL,
  USER_PROFILE_LOGOUT_SUCCESS,
  USER_PROFILE_LOGOUT_REQUEST,
  USER_PROFILE_LOGOUT_FAIL,
  USER_PROFILE_GETPROFILE_REQUEST,
  USER_PROFILE_GETPROFILE_SUCCESS,
  USER_PROFILE_GETPROFILE_FAIL,
  USER_PROFILE_GETPROFILE,
} from './actions';

const getUserApi = () => getConfig().userApi;

function fetchUserInfo() {
  return callApi('myProfile', `${getUserApi()}/me`, {}, [
    USER_PROFILE_GETPROFILE_REQUEST,
    USER_PROFILE_GETPROFILE_SUCCESS,
    USER_PROFILE_GETPROFILE_FAIL,
  ]);
}

function login(
  email,
  // username,
  password
) {
  return callApi(
    'login',
    `${getUserApi()}/login`,
    {
      path: 'http://localhost:3008/api/users/login',
      method: METHOD.POST,
      body: {
        email,
        // username: username,
        password,
      },
    },
    [USER_PROFILE_LOGIN_REQUEST, USER_PROFILE_LOGIN_SUCCESS, USER_PROFILE_LOGIN_FAIL]
  );
}

function clearAccessToken() {
  const { removeAccessToken } = accessTokenService();
  removeAccessToken();
}

function clearSession() {
  sessionStorage.clear();
}

function logout() {
  getApolloClient().resetStore();
  return callApi(
    'logout',
    `${getUserApi()}/logout`,
    {
      method: METHOD.POST,
    },
    [USER_PROFILE_LOGOUT_REQUEST, USER_PROFILE_LOGOUT_SUCCESS, USER_PROFILE_LOGOUT_FAIL]
  );
}

export function* onLoginPass() {
  yield takeEvery(USER_PROFILE_LOGIN_SUCCESS, function* () {
    yield put(fetchUserInfo());
  });
}

export function* clearUserInfo() {
  yield takeEvery(USER_PROFILE_LOGOUT_SUCCESS, function* () {
    yield put(setProfile(null));
    yield put(setProfileLoading(false));
    clearSession();
    clearAccessToken();
  });
}

export function* requestUserInfo() {
  yield takeEvery(USER_PROFILE_GETPROFILE, function* () {
    yield put(fetchUserInfo());
  });
}

export function* performLogin() {
  yield takeLatest(USER_PROFILE_LOGIN, function* doLogin({ payload }) {
    // yield put(login(payload.username, payload.password));
    yield put(login(payload.email, payload.password));
  });
}

export function* performLogout() {
  yield takeLatest(USER_PROFILE_LOGOUT, function* doLogout() {
    yield put(logout());
  });
}

export default [onLoginPass(), performLogin(), performLogout(), requestUserInfo(), clearUserInfo()];
